import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const DataContext = createContext(null);

export const DataProvider = ({ children }) => {
  const [sales, setSales] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [receipts, setReceipts] = useState([]);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const [s, e, r, st] = await Promise.all([
        api.get("/sales"),
        api.get("/expenses"),
        api.get("/receipts"),
        api.get("/settings"),
      ]);
      setSales(s.data || []);
      setExpenses(e.data || []);
      setReceipts(r.data || []);
      setSettings(st.data || null);
    } finally {
      setLoading(false);
    }
  }, []); // api is a stable module import; setters from useState are stable

  const refreshSettings = useCallback(async () => {
    const { data } = await api.get("/settings");
    setSettings(data);
  }, []); // api + setSettings are stable

  useEffect(() => { refresh(); }, [refresh]);

  // Memoize context value to prevent unnecessary re-renders of consumers
  const value = useMemo(
    () => ({ sales, expenses, receipts, settings, loading, refresh, refreshSettings, setSales, setExpenses, setReceipts, setSettings }),
    [sales, expenses, receipts, settings, loading, refresh, refreshSettings]
  );

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};

export const useData = () => useContext(DataContext);
